import {Box, Center, Flex, Image, Text, SimpleGrid} from '@chakra-ui/react'
import VolumeIcon from '@assets/svgs/revise/volume.svg'
import CheckedIcon from '@assets/svgs/revise/checked.svg'
import FailedIcon from '@assets/svgs/revise/failed.svg'
import {useEffect, useState} from 'react'
import rightAudio from '@assets/audios/right.mp3'
import wrongAudio from '@assets/audios/wrong.mp3'
import useExamRoom from './useExamRoom'
import {useDispatch, useSelector} from 'react-redux'
import {updateIsShowHeaderBtn} from '@redux/revise/revise'

const Exercise1 = () => {
  const {currentQuestion} = useSelector((state: any) => state.revise)
  const {handlePlayAudio, handlePauseAudio} = useExamRoom()
  const [currentSelector, setCurrentSelector] = useState<any>()
  const [answers, setAnswers] = useState<any>([])
  const dispatch = useDispatch()

  useEffect(() => {
    setTimeout(() => {
      handlePlayAudio(currentQuestion?.data.audio)
    }, 1500)
  }, [currentQuestion])

  //Đổi thứ tự các câu hỏi
  useEffect(() => {
    //API trả về 2 dạng field cho đáp án: phrase/vi_phrase hoặc text_en/text_vi
    const newAnswer = [...(currentQuestion?.data?.answers ?? [])].map(
      (item: any) => ({
        ...item,
        phrase: item.phrase ?? item.text_en,
        vi_phrase: item.vi_phrase ?? item.text_vi,
      }),
    )
    for (let i = newAnswer.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[newAnswer[i], newAnswer[j]] = [newAnswer[j], newAnswer[i]]
    }
    setAnswers(newAnswer)
  }, [])

  const handleClickAnswer = (answer: any) => {
    if (currentSelector) {
      return
    }
    if (answer.is_true_answer) {
      new Audio(rightAudio).play()
    } else {
      new Audio(wrongAudio).play()
    }
    handlePauseAudio()
    dispatch(updateIsShowHeaderBtn(true))
    setCurrentSelector(answer)
  }

  return (
    <Box className="container-xl" mt={'60px'}>
      <Flex flexDirection={'column'}>
        <Box borderRadius={'24px'} bg={'white'}>
          <Box p={{base: '30px 16px 16px 16px', md: '40px 100px 100px 100px'}}>
            <Text
              color={'#8C8C8C'}
              fontSize={'16px'}
              textTransform={'uppercase'}
              align={'center'}>
              {currentQuestion?.data.title}
            </Text>
            <Flex
              justifyContent={'center'}
              mt={'16px'}
              gap={'16px'}
              alignItems={'center'}>
              <Center
                flexShrink={0}
                cursor={'pointer'}
                h={{base: '40px', md: '56px'}}
                w={{base: '40px', md: '56px'}}
                borderRadius={'50%'}
                bg={'rgba(1, 172, 255, 0.10)'}
                onClick={() => {
                  handlePlayAudio(currentQuestion?.data.audio)
                }}>
                <Image h={'24px'} w={'24px'} src={VolumeIcon} />
              </Center>
              <Text fontSize={{base: '16px', md: '24px'}} fontWeight={600}>
                {currentQuestion?.data.sentence
                  .split(' ')
                  .map((item: any, index: any) => (
                    <Text
                      key={index}
                      as={'span'}
                      fontFamily={item.includes('_') ? 'Lexend' : 'unset'}>
                      {`${item} `}
                    </Text>
                  ))}
              </Text>
            </Flex>
            {currentSelector && (
              <Text fontSize={'16px'} align={'center'}>
                {currentQuestion?.data.vi_sentence}
              </Text>
            )}

            <SimpleGrid
              columns={2}
              spacing={{base: '24px', md: '64px'}}
              mt={{base: '40px', md: '100px'}}>
              {answers?.map((item: any, index: any) => {
                return (
                  <Center
                    key={index}
                    position={'relative'}
                    cursor={'pointer'}
                    border={'3px solid #F0F0F0'}
                    flexDirection={'column'}
                    borderColor={
                      currentSelector === item ||
                      (currentSelector && item.is_true_answer)
                        ? item.is_true_answer
                          ? '#73D13D'
                          : '#FFA39E'
                        : 'F0F0F0'
                    }
                    borderRadius={'16px'}
                    p={{base: '16px', md: '24px'}}
                    bg={
                      currentSelector === item ||
                      (currentSelector && item.is_true_answer)
                        ? item.is_true_answer
                          ? '#F6FFED'
                          : 'unset'
                        : 'unset'
                    }
                    onClick={() => handleClickAnswer(item)}>
                    <Text
                      fontSize={'24px'}
                      color={
                        currentSelector === item ||
                        (currentSelector && item.is_true_answer)
                          ? item.is_true_answer
                            ? '#73D13D'
                            : '#FF4D4F'
                          : 'unset'
                      }>
                      {item.phrase}
                    </Text>
                    {currentSelector && item.vi_phrase && (
                      <Text
                        fontSize={'16px'}
                        color={
                          currentSelector === item ||
                          (currentSelector && item.is_true_answer)
                            ? item.is_true_answer
                              ? '#73D13D'
                              : '#FF4D4F'
                            : 'unset'
                        }>
                        {item.vi_phrase}
                      </Text>
                    )}
                    {(currentSelector === item ||
                      (currentSelector && item.is_true_answer)) && (
                      <Image
                        position={'absolute'}
                        top={'-10px'}
                        right={'-10px'}
                        src={item.is_true_answer ? CheckedIcon : FailedIcon}
                      />
                    )}
                  </Center>
                )
              })}
            </SimpleGrid>
          </Box>
        </Box>
      </Flex>
    </Box>
  )
}

export default Exercise1
